// tslint:disable:jsx-no-multiline-js
import * as React from 'react';

import * as CommonUx from '@abb/common-ux';

interface IHeaderProps {
  title: string;
}
export const Header: React.SFC<IHeaderProps> = (props: IHeaderProps) => {
  return (
    <div className='row'>
      <div className='col-sm-8'>
        {props.title}
      </div>
      <div className='col-sm-3' style={{textAlign: 'right'}}>
        <span style={{fontSize: '10px'}}>* Required Fields</span>
      </div>
    </div>
  );
};
